<template>
  <div _tmplitem="357" class="dv-full-screen-container" :style="css">
    <div _tmplitem="357"
         style="position: absolute;--animation-linear:1;--animation-type:ease;width:1920px;height:1080px;background-color:rgb(43 44 45);"
         class="div-full-screen">
      <div _tmplitem="357" v-if="readDataPermission.group15r4" class="group15r4 foolt"
           style="overflow: hidden; width: 100px; height: 100px;top: 180px; left: 1320px;position: absolute; z-index: 1058;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="onUnder"
             style=" width: 100px; height: 100px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="242" v-if="readDataPermission.elstatisticses3" class="bigitem elstatisticses3 "
               style="top: 25px; left: 0px; position: absolute;width: 100px; height: 30px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="242" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <elstatistic _tmplitem="239" groupseparator="," :precision="0" :value="fromData.elstatisticses3" title=""
                           style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"
                           titleicon=""
                           titlestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;" formatter="{value}"
                           valuestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;font-weight:bold ;font-family:'Roboto';color: #fff;"
                           prefixicon="" prefixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           suffixicon="" :isrowshow="false"
                           suffixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"></elstatistic>
            </div>
          </div>
          <div _tmplitem="242" v-if="readDataPermission.titleo00r" class="bigitem titleo00r "
               style="top: 65px; left: 0px; position: absolute;width: 100px; height: 20px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="242" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="240" ref="titleo00r" :w="100" :h="20" :val="fromData.titleo00r"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="242" v-if="readDataPermission.img3w5v" class="bigitem img3w5v "
               style="top: 0px; left: 0px; position: absolute;width: 100px; height: 100px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="242" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="241" :url="$staticUrl('/statics/2025/09/13/index_bg1_20250913115446A059.png')"
                      w="100" h="100" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.groupgkxn" class="groupgkxn foolt3"
           style="overflow: hidden; width: 100px; height: 100px;top: 180px; left: 1180px;position: absolute; z-index: 1057;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="onUnder"
             style=" width: 100px; height: 100px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="246" v-if="readDataPermission.elstatisticv6j3" class="bigitem elstatisticv6j3 "
               style="top: 25px; left: 0px; position: absolute;width: 100px; height: 30px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="246" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <elstatistic _tmplitem="243" groupseparator="," :precision="0" :value="fromData.elstatisticv6j3" title=""
                           style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"
                           titleicon="" titlestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           formatter="{value}"
                           valuestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;font-weight:bold ;font-family:'Roboto';color: #fff;"
                           prefixicon="" prefixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           suffixicon="" :isrowshow="false"
                           suffixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"></elstatistic>
            </div>
          </div>
          <div _tmplitem="246" v-if="readDataPermission.titlerfmk" class="bigitem titlerfmk "
               style="top: 65px; left: 0px; position: absolute;width: 100px; height: 20px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="246" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="244" ref="titlerfmk" :w="100" :h="20" :val="fromData.titlerfmk"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="246" v-if="readDataPermission.imgtp15" class="bigitem imgtp15 "
               style="top: 0px; left: 0px; position: absolute;width: 100px; height: 100px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="246" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="245" :url="$staticUrl('/statics/2025/09/13/index_bg1_20250913115446A059.png')"
                      w="100" h="100" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.groupaf5n" class="groupaf5n foolt"
           style="overflow: hidden; width: 100px; height: 100px;top: 180px; left: 1040px;position: absolute; z-index: 1056;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="onUnder"
             style=" width: 100px; height: 100px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="250" v-if="readDataPermission.elstatisticz0ua" class="bigitem elstatisticz0ua "
               style="top: 25px; left: 0px; position: absolute;width: 100px; height: 30px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="250" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <elstatistic _tmplitem="247" groupseparator="," :precision="0" :value="fromData.elstatisticz0ua" title=""
                           style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"
                           titleicon="" titlestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           formatter="{value}"
                           valuestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;font-weight:bold ;font-family:'Roboto';color: #fff;"
                           prefixicon="" prefixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           suffixicon="" :isrowshow="false"
                           suffixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"></elstatistic>
            </div>
          </div>
          <div _tmplitem="250" v-if="readDataPermission.title8paa" class="bigitem title8paa "
               style="top: 65px; left: 0px; position: absolute;width: 100px; height: 20px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="250" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="248" ref="title8paa" :w="100" :h="20" :val="fromData.title8paa"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="250" v-if="readDataPermission.imgd3oa" class="bigitem imgd3oa "
               style="top: 0px; left: 0px; position: absolute;width: 100px; height: 100px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="250" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="249" :url="$staticUrl('/statics/2025/09/13/index_bg1_20250913115446A059.png')"
                      w="100" h="100" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.groupowma" class="groupowma foolt3"
           style="overflow: hidden; width: 100px; height: 100px;top: 180px; left: 900px;position: absolute; z-index: 1055;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" @click="onUnder" class=""
             style=" width: 100px; height: 100px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="254" v-if="readDataPermission.elstatisticzaet" class="bigitem elstatisticzaet "
               style="top: 25px; left: 0px; position: absolute;width: 100px; height: 30px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="254" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <elstatistic _tmplitem="251" groupseparator="," :precision="0" :value="fromData.elstatisticzaet" title=""
                           style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"
                           titleicon="" titlestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           formatter="{value}"
                           valuestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;font-weight:bold ;font-family:'Roboto';color: #fff;"
                           prefixicon="" prefixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           suffixicon="" :isrowshow="false"
                           suffixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"></elstatistic>
            </div>
          </div>
          <div _tmplitem="254" v-if="readDataPermission.titlespec" class="bigitem titlespec "
               style="top: 65px; left: 0px; position: absolute;width: 100px; height: 20px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="254" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="252" ref="titlespec" :w="100" :h="20" :val="fromData.titlespec"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="254" v-if="readDataPermission.imgry1w" class="bigitem imgry1w "
               style="top: 0px; left: 0px; position: absolute;width: 100px; height: 100px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="254" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="253" :url="$staticUrl('/statics/2025/09/13/index_bg1_20250913115446A059.png')"
                      w="100" h="100" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.groupcqju" class="groupcqju foolt"
           style="overflow: hidden; width: 100px; height: 100px;top: 180px; left: 760px;position: absolute; z-index: 1054;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" @click="onFunds" class=""
             style=" width: 100px; height: 100px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="258" v-if="readDataPermission.elstatistic20qd" class="bigitem elstatistic20qd "
               style="top: 25px; left: 0px; position: absolute;width: 100px; height: 30px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="258" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <elstatistic _tmplitem="255" groupseparator="," :precision="0" :value="fromData.elstatistic20qd" title=""
                           style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"
                           titleicon="" titlestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           formatter="{value}"
                           valuestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;font-weight:bold ;font-family:'Roboto';color: #fff;"
                           prefixicon="" prefixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           suffixicon="" :isrowshow="false"
                           suffixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"></elstatistic>
            </div>
          </div>
          <div _tmplitem="258" v-if="readDataPermission.titleqbve" class="bigitem titleqbve "
               style="top: 65px; left: 0px; position: absolute;width: 100px; height: 20px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="258" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="256" ref="titleqbve" :w="100" :h="20" :val="fromData.titleqbve"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="258" v-if="readDataPermission.img4zvh" class="bigitem img4zvh "
               style="top: 0px; left: 0px; position: absolute;width: 100px; height: 100px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="258" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="257" :url="$staticUrl('/statics/2025/09/13/index_bg1_20250913115446A059.png')"
                      w="100" h="100" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.group3hoz" class="group3hoz foolt3"
           style="overflow: hidden; width: 100px; height: 100px;top: 180px; left: 620px;position: absolute; z-index: 1053;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="toFinanceClicek"
             style=" width: 100px; height: 100px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="262" v-if="readDataPermission.elstatistickmaj" class="bigitem elstatistickmaj "
               style="top: 25px; left: 0px; position: absolute;width: 100px; height: 30px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="262" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <elstatistic _tmplitem="259" groupseparator="," :precision="0" :value="fromData.elstatistickmaj" title=""
                           style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"
                           titleicon="" titlestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           formatter="{value}"
                           valuestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;font-weight:bold ;font-family:'Roboto';color: #fff;"
                           prefixicon="" prefixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           suffixicon="" :isrowshow="false"
                           suffixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"></elstatistic>
            </div>
          </div>
          <div _tmplitem="262" v-if="readDataPermission.titleggxx" class="bigitem titleggxx "
               style="top: 65px; left: 0px; position: absolute;width: 100px; height: 20px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="262" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="260" ref="titleggxx" :w="100" :h="20" :val="fromData.titleggxx"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="262" v-if="readDataPermission.imgam55" class="bigitem imgam55 "
               style="top: 0px; left: 0px; position: absolute;width: 100px; height: 100px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="262" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="261" :url="$staticUrl('/statics/2025/09/13/index_bg1_20250913115446A059.png')"
                      w="100" h="100" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.vuecomm03xy" class="bigitem vuecomm03xy bigechartitem"
           style="top: 795px; left: 1481px;position: absolute; width: 410px; height: 260px; transform: translate(0px, 0px); z-index: 1052;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <vuecomm03xy ref="vuecomm03xy" :list="todolist" :w="410" :h="260"
                       cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></vuecomm03xy>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.grop2taf" class="grop2taf foolt"
           style="overflow: hidden; width: 100px; height: 100px;top: 180px; left: 480px;position: absolute; z-index: 1051;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="onUnder"
             style=" width: 100px; height: 100px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="267" v-if="readDataPermission.elstatistic1ay7" class="bigitem elstatistic1ay7 "
               style="top: 25px; left: 0px; position: absolute;width: 100px; height: 30px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="267" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <elstatistic _tmplitem="264" groupseparator="," :precision="0" :value="fromData.elstatistic1ay7" title=""
                           style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:30px ;font-size:18px ;border-radius:0px;border-width:0px ;border-style:solid ;color:rgb(255, 255, 255) ;justify-content:center;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"
                           titleicon="" titlestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           formatter="{value}"
                           valuestyle="--animation-linear:1;--animation-type:ease;font-size:24px ;font-weight:bold ;font-family:'Roboto';color: #fff;"
                           prefixicon="" prefixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"
                           suffixicon="" :isrowshow="false"
                           suffixstyle="--animation-linear:1;--animation-type:ease;font-size:24px ;"></elstatistic>
            </div>
          </div>
          <div _tmplitem="267" v-if="readDataPermission.title69s1" class="bigitem title69s1 "
               style="top: 65px; left: 0px; position: absolute;width: 100px; height: 20px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="267" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="265" ref="title69s1" :w="100" :h="20" :val="fromData.title69s1"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#7DE8DE ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="267" v-if="readDataPermission.img6qy3" class="bigitem img6qy3 "
               style="top: 0px; left: 0px; position: absolute;width: 100px; height: 100px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="267" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="266" :url="$staticUrl('/statics/2025/09/13/index_bg1_20250913115446A059.png')"
                      w="100" h="100" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      
      
      <div _tmplitem="357" v-if="readDataPermission.groupjw0x" class="groupjw0x "
           style="overflow: hidden; width: 222px; height: 36px;top: 1017px; left: 1300px;position: absolute; z-index: 1046;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="onUnder"
             style=" width: 222px; height: 36px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="287" v-if="readDataPermission.titlev940" class="bigitem titlev940 "
               style="top: 0px; left: 60px; position: absolute;width: 162px; height: 20px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="287" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="284" ref="titlev940" :w="162" :h="20" :val="fromData.titlev940"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="287" v-if="readDataPermission.imgfm5d" class="bigitem imgfm5d "
               style="top: 0px; left: 30px; position: absolute;width: 18px; height: 18px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="287" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="285"
                      :url="$staticUrl('/statics/2025/09/13/permission_20250913105036A056.png')" w="18" h="18"
                      rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
          <div _tmplitem="287" v-if="readDataPermission.imgkp9k" class="bigitem imgkp9k "
               style="top: 6px; left: 0px; position: absolute;width: 140px; height: 30px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="287" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="286" :url="$staticUrl('/statics/2025/09/13/path_20250913092321A050.png')"
                      w="140" h="30" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.group8sm7" class="group8sm7 "
           style="overflow: hidden; width: 222px; height: 36px;top: 1017px; left: 1144px;position: absolute; z-index: 1045;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="onUnder"
             style=" width: 222px; height: 36px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="291" v-if="readDataPermission.titleca4z" class="bigitem titleca4z "
               style="top: 0px; left: 60px; position: absolute;width: 162px; height: 20px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="291" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="288" ref="titleca4z" :w="162" :h="20" :val="fromData.titleca4z"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="291" v-if="readDataPermission.imgrmh2" class="bigitem imgrmh2 "
               style="top: 0px; left: 30px; position: absolute;width: 18px; height: 18px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="291" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="289" :url="$staticUrl('/statics/2025/09/13/reward_20250913104746A055.png')"
                      w="18" h="18" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
          <div _tmplitem="291" v-if="readDataPermission.imgta96" class="bigitem imgta96 "
               style="top: 6px; left: 0px; position: absolute;width: 140px; height: 30px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="291" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="290" :url="$staticUrl('/statics/2025/09/13/path_20250913092321A050.png')"
                      w="140" h="30" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.groupxhta" class="groupxhta "
           style="overflow: hidden; width: 222px; height: 36px;top: 1017px; left: 984px;position: absolute; z-index: 1044;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="onUnder"
             style=" width: 222px; height: 36px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="295" v-if="readDataPermission.titlejx91" class="bigitem titlejx91 "
               style="top: 0px; left: 60px; position: absolute;width: 162px; height: 20px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="295" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="292" ref="titlejx91" :w="162" :h="20" :val="fromData.titlejx91"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="295" v-if="readDataPermission.img265r" class="bigitem img265r "
               style="top: 0px; left: 30px; position: absolute;width: 20px; height: 18px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="295" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="293"
                      :url="$staticUrl('/statics/2025/09/13/department_20250913103254A054.png')" w="20" h="18"
                      rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
          <div _tmplitem="295" v-if="readDataPermission.imghaz6" class="bigitem imghaz6 "
               style="top: 6px; left: 0px; position: absolute;width: 140px; height: 30px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="295" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="294" :url="$staticUrl('/statics/2025/09/13/path_20250913092321A050.png')"
                      w="140" h="30" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.groupfuav" class="groupfuav "
           style="overflow: hidden; width: 217px; height: 36px;top: 1017px; left: 824px;position: absolute; z-index: 1043;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="onNotice"
             style=" width: 217px; height: 36px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="299" v-if="readDataPermission.titleogry" class="bigitem titleogry "
               style="top: 0px; left: 55px; position: absolute;width: 162px; height: 20px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="299" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="296" ref="titleogry" :w="162" :h="20" :val="fromData.titleogry"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="299" v-if="readDataPermission.img83qo" class="bigitem img83qo "
               style="top: 0px; left: 30px; position: absolute;width: 18px; height: 18px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="299" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="297" :url="$staticUrl('/statics/2025/09/15/notice_20250915114550A084.png')"
                      w="18" h="18" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
          <div _tmplitem="299" v-if="readDataPermission.imga6n7" class="bigitem imga6n7 "
               style="top: 6px; left: 0px; position: absolute;width: 140px; height: 30px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="299" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="298" :url="$staticUrl('/statics/2025/09/13/path_20250913092321A050.png')"
                      w="140" h="30" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.group2e8g" class="group2e8g "
           style="overflow: hidden; width: 217px; height: 36px;top: 1017px; left: 644px;position: absolute; z-index: 1042;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="toEvenClicek"
             style=" width: 217px; height: 36px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="303" v-if="readDataPermission.titlejp46" class="bigitem titlejp46 "
               style="top: 0px; left: 55px; position: absolute;width: 162px; height: 20px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="303" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="300" ref="titlejp46" :w="162" :h="20" :val="fromData.titlejp46"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="303" v-if="readDataPermission.imgk4ch" class="bigitem imgk4ch "
               style="top: 0px; left: 30px; position: absolute;width: 18px; height: 20px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="303" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="301" :url="$staticUrl('/statics/2025/09/13/intervene_20250913102037A053.png')"
                      w="18" h="20" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
          <div _tmplitem="303" v-if="readDataPermission.imgudgm" class="bigitem imgudgm "
               style="top: 6px; left: 0px; position: absolute;width: 160px; height: 30px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="303" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="302" :url="$staticUrl('/statics/2025/09/13/path_20250913092321A050.png')"
                      w="160" h="30" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.gropt4bd" class="gropt4bd "
           style="overflow: hidden; width: 217px; height: 36px;top: 1017px; left: 464px;position: absolute; z-index: 1041;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class="" @click="onUnder"
             style=" width: 217px; height: 36px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="307" v-if="readDataPermission.titlek7hh" class="bigitem titlek7hh "
               style="top: 0px; left: 55px; position: absolute;width: 162px; height: 20px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="307" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="304" ref="titlek7hh" :w="162" :h="20" :val="fromData.titlek7hh"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:13px ;color:#418484 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:20px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="307" v-if="readDataPermission.imghk3g" class="bigitem imghk3g "
               style="top: 0px; left: 30px; position: absolute;width: 17px; height: 21px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="307" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="305" :url="$staticUrl('/statics/2025/09/13/archives_20250913093134A051.png')"
                      w="17" h="21" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
          <div _tmplitem="307" v-if="readDataPermission.imgd9qs" class="bigitem imgd9qs "
               style="top: 6px; left: 0px; position: absolute;width: 160px; height: 30px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="307" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="306" :url="$staticUrl('/statics/2025/09/13/path_20250913092321A050.png')"
                      w="160" h="30" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titlem0h3" class="bigitem titlem0h3 "
           style="top: 745px; left: 1523px;position: absolute; width: 162px; height: 41.86px; transform: translate(0px, 0px); z-index: 1040;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="308" ref="titlem0h3" :w="162" :h="41.86" :val="fromData.titlem0h3"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.img8tvq" class="bigitem img8tvq "
           style="top: 755px; left: 1481px;position: absolute; width: 410px; height: 30.35px; transform: translate(0px, 0px); z-index: 1039;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <bigimg _tmplitem="309" :url="$staticUrl('/statics/2025/09/12/bg1_20250912155317A043.png')" w="410"
                  h="30.35" rotatetype="" rotatetime=""></bigimg>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.eltableuzwk" class="bigitem eltableuzwk "
           style="top: 525px; left: 1481px;position: absolute; width: 410px; height: 140px; transform: translate(0px, 0px); z-index: 1038;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;height:190px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <eltable _tmplitem="310" :header-row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}"
                   :row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}" :isheadshow="true"
                   :showordernum="false" tablebackgroundcolor="#03161C" tableheadcolor="rgba(21,160,151,0.2)"
                   tablerowhovercolor="rgba(21,160,151,0.2)" tablerowcolor="#03161C" tablerowdoublecolor="#03161C"
                   tablebordercolor="rgba(3,220,228,0.2)" tableheadfontcolor="#D8F0FF" tablehoverfontcolor="#fff"
                   tablerowfontcolor="#DF4D50" :elcolumn="controlData.eltableuzwk" :tabledata="fromData.eltableuzwk"
                   :h="140" :w="410"></eltable>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.scrollingtable8d40" class="bigitem scrollingtable8d40 "
           style="top: 631px; left: 1481px;position: absolute; width: 410px; height: 108px; transform: translate(0px, 0px); z-index: 1037;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;height:190px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <scrollingtable _tmplitem="311" :header-row-style="{'font-size':'12px','line-height':'18px'}"
                          :row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}"
                          :isheadshow="false" :showordernum="false" :scrollnum="3" tablebackgroundcolor="#03161C"
                          tableheadcolor="#03161C" tablerowhovercolor="rgba(21,160,151,0.2)" tablerowcolor="#03161C"
                          tablerowdoublecolor="#03161C" tablebordercolor="rgba(3,220,228,0.2)" tableheadfontcolor="#fff"
                          tablehoverfontcolor="#fff" tablerowfontcolor="#C3D2DE" :scrollheight="1" :scrolltime="40"
                          :elcolumn="controlData.scrollingtable8d40" :tabledata="fromData.scrollingtable8d40" :h="108"
                          :w="410"></scrollingtable>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.groplyas" class="groplyas "
           style="overflow: hidden; width: 397px; height: 23px;top: 495px; left: 1481px;position: absolute; z-index: 1036;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class=""
             style=" width: 397px; height: 23px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="317" v-if="readDataPermission.title8r6h" class="bigitem title8r6h "
               style="top: 0px; left: 170px; position: absolute;width: 60px; height: 23px; transform: translate(0px, 0px); z-index: 105;pointer-events: auto;  ">
            <div _tmplitem="317" class="itemcontent " @click="onUnder"
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:rgba(236,255,253,0.5) ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#00594E ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="312" ref="title8r6h" :w="60" :h="23" :val="fromData.title8r6h"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:rgba(236,255,253,0.5) ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#00594E ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);background: linear-gradient( 180deg, rgba(15,159,152,0) 0%, rgba(17,160,143,0.95) 100%);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="317" v-if="readDataPermission.title6tqt" class="bigitem title6tqt "
               style="top: 0px; left: 255px; position: absolute;width: 60px; height: 23px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
            <div _tmplitem="317" class="itemcontent " @click="onUnder"
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:rgba(236,255,253,0.5) ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#00594E ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="313" ref="title6tqt" :w="60" :h="23" :val="fromData.title6tqt"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:rgba(236,255,253,0.5) ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#00594E ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);background: linear-gradient( 180deg, rgba(15,159,152,0) 0%, rgba(17,160,143,0.95) 100%);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="317" v-if="readDataPermission.titlemhfg" class="bigitem titlemhfg "
               style="top: 0px; left: 337px; position: absolute;width: 60px; height: 23px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
            <div _tmplitem="317" class="itemcontent " @click="onUnder"
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:rgba(236,255,253,0.5) ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#00594E ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="314" ref="titlemhfg" :w="60" :h="23" :val="fromData.titlemhfg"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:rgba(236,255,253,0.5) ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#00594E ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);background: linear-gradient( 180deg, rgba(15,159,152,0) 0%, rgba(17,160,143,0.95) 100%);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="317" v-if="readDataPermission.titlevrtc" class="bigitem titlevrtc "
               style="top: 0px; left: 85px; position: absolute;width: 60px; height: 23px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="317" class="itemcontent " @click="onUnder"
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:rgba(236,255,253,0.5) ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#00594E ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="315" ref="titlevrtc" :w="60" :h="23" :val="fromData.titlevrtc"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:rgba(236,255,253,0.5) ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#00594E ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);background: linear-gradient( 180deg, rgba(15,159,152,0) 0%, rgba(17,160,143,0.95) 100%);"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="317" v-if="readDataPermission.title2kr7" class="bigitem title2kr7 "
               style="top: 0px; left: 0px; position: absolute;width: 60px; height: 23px; transform: translate(0px, 0px); z-index: 101;pointer-events: painted;  ">
            <div _tmplitem="317" class="itemcontent " @click="onUnder"
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#D8FFFD ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#1ED6D0 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="316" ref="title2kr7" :w="60" :h="23" :val="fromData.title2kr7"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#D8FFFD ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#1ED6D0 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);background: linear-gradient( 180deg, rgba(15,159,138,0) 0%, rgba(17,158,160,0.95) 100%);"></titlecontrol>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.title51he" class="bigitem title51he "
           style="top: 324px; left: 1849px;position: absolute; width: 44px; height: 23px; transform: translate(0px, 0px); z-index: 1035;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent " @click="onUnder"
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="318" ref="title51he" :w="44" :h="23" :val="fromData.title51he"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titleu739" class="bigitem titleu739 "
           style="top: 352px; left: 1849px;position: absolute; width: 44px; height: 23px; transform: translate(0px, 0px); z-index: 1034;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent " @click="onUnder"
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="319" ref="titleu739" :w="44" :h="23" :val="fromData.titleu739"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titlel4z0" class="bigitem titlel4z0 "
           style="top: 380px; left: 1849px;position: absolute; width: 44px; height: 23px; transform: translate(0px, 0px); z-index: 1033;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent " @click="onUnder"
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="320" ref="titlel4z0" :w="44" :h="23" :val="fromData.titlel4z0"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titlewpr7" class="bigitem titlewpr7 "
           style="top: 268px; left: 1849px;position: absolute; width: 44px; height: 23px; transform: translate(0px, 0px); z-index: 1032;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent " @click="onUnder"
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="321" ref="titlewpr7" :w="44" :h="23" :val="fromData.titlewpr7"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titlejllp" class="bigitem titlejllp "
           style="top: 296px; left: 1849px;position: absolute; width: 44px; height: 23px; transform: translate(0px, 0px); z-index: 1031;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent " @click="onUnder"
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="322" ref="titlejllp" @click="onUnder" :w="44" :h="23" :val="fromData.titlejllp"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titlebo0q" class="bigitem titlebo0q "
           style="top: 408px; left: 1849px;position: absolute; width: 44px; height: 23px; transform: translate(0px, 0px); z-index: 1030;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent " @click="onUnder"
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="323" ref="titlebo0q" :w="44" :h="23" :val="fromData.titlebo0q"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titled0ef" class="bigitem titled0ef "
           style="top: 240px; left: 1849px;position: absolute; width: 44px; height: 23px; transform: translate(0px, 0px); z-index: 1029;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent " @click="onUnder"
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="324" ref="titled0ef" :w="44" :h="23" :val="fromData.titled0ef"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.title9oqd" class="bigitem title9oqd "
           style="top: 212px; left: 1849px;position: absolute; width: 44px; height: 23px; transform: translate(0px, 0px); z-index: 1028;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent " @click="onUnder"
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="325" ref="title9oqd" :w="44" :h="23" :val="fromData.title9oqd"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titled8ag" class="bigitem titled8ag "
           style="top: 184px; left: 1849px;position: absolute; width: 44px; height: 23px; transform: translate(0px, 0px); z-index: 1027;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent " @click="onUnder"
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="326" ref="titled8ag" :w="44" :h="23" :val="fromData.titled8ag"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:10px ;color:#75DFD4 ;border-radius:3px;border-width:1px ;border-style:solid ;border-color:#76E1D7 ;line-height:20px ;text-align:center;font-family:'Microsoft YaHei';background-color:rgba(118,225,215,0.2);--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.title3x4x" class="bigitem title3x4x "
           style="top: 450px; left: 1523px;position: absolute; width: 162px; height: 41.86px; transform: translate(0px, 0px); z-index: 1026;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="327" ref="title3x4x" :w="162" :h="41.86" :val="fromData.title3x4x"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.imgb8x0" class="bigitem imgb8x0 "
           style="top: 460px; left: 1481px;position: absolute; width: 410px; height: 30.35px; transform: translate(0px, 0px); z-index: 1025;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <bigimg _tmplitem="328" :url="$staticUrl('/statics/2025/09/12/bg1_20250912155317A043.png')" w="410"
                  h="30.35" rotatetype="" rotatetime=""></bigimg>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.chartfxf1" class="bigitem chartfxf1 bigechartitem"
           style="top: 150px; left: 1481px;position: absolute; width: 410px; height: 300px; transform: translate(0px, 0px); z-index: 1024;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <myechart _tmplitem="329" ref="chartfxf1" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8"
                    :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chartfxf1"></myechart>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titleww22" class="bigitem titleww22 "
           style="top: 110px; left: 1523px;position: absolute; width: 162px; height: 41.86px; transform: translate(0px, 0px); z-index: 1023;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="330" ref="titleww22" :w="162" :h="41.86" :val="fromData.titleww22"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.imgrng4" class="bigitem imgrng4 "
           style="top: 120px; left: 1481px;position: absolute; width: 410px; height: 30.35px; transform: translate(0px, 0px); z-index: 1022;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <bigimg _tmplitem="331" :url="$staticUrl('/statics/2025/09/12/bg1_20250912155317A043.png')" w="410"
                  h="30.35" rotatetype="" rotatetime=""></bigimg>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.title6tls" class="bigitem title6tls "
           style="top: 20px; left: 1720px;position: absolute; width: 100px; height: 23px; transform: translate(0px, 0px); z-index: 1021;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:#7BE6DD ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:22px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">

          <titlecontrol _tmplitem="332" ref="title6tls" :w="100" :h="23" :val="fromData.title6tls"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:#7BE6DD ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:22px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
        </div>
      </div>
      <!-- 地图 -->
       <!-- <div style="background-color: #0ff;"> -->
<mapBg></mapBg>

       <!-- </div> -->

      <div _tmplitem="357" v-if="readDataPermission.grop7cta" class="grop7cta wrapper_1"
           style="overflow: hidden; width: 786px; height: 699px;top: 288px; left: 576px;position: absolute; z-index: 1020;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class=""
             style=" width: 786px; height: 699px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="335" v-if="readDataPermission.chartyffk" class="bigitem chartyffk "
               style="top: 0px; left: 0px; position: absolute;width: 786px; height: 699px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="335" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <myechart _tmplitem="333" ref="chartyffk" orienttype="horizontal" :echartroll="false"
                        :maxechartrollnum="8" :echartrolltime="2" mapcity="china,410000,410500"
                        mapcode="map175764609538088" mapurl="" :options="fromData.chartyffk"></myechart>
            </div>
          </div>
          <div _tmplitem="335" v-if="readDataPermission.imgwyau" class="bigitem imgwyau "
               style="top: 29px; left: 84.55999999999995px; position: absolute;width: 646.72px; height: 650px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="335" class="itemcontent animation-revolve"
                 style="--animation-linear:1;--animation-type:ease;opacity:0.5;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.1s;--animation-type:linear;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <!-- <bigimg _tmplitem="334" url="https://govern.zyzhkjbj.com/statics/2025/09/12/map_bg_20250912155022A042.png" w="646.72" h="650" rotatetype="" rotatetime=""></bigimg> -->
            </div>
          </div>
        </div>
      </div>



      <div
          v-if="tooltipVisible && tooltipData"
          ref="tooltipRef"
          style="width: 320px; height: 160px;position: absolute; z-index: 100075;"
          :style="{
                    left: tooltipLeft + 'px',
                    top: tooltipTop + 'px',
                }">
        <div style="position: relative;">
          <div style="position: absolute;z-index: 100076; top: 33px;right: 95px;width: 70px;text-align: center">
            <div style="color: #E8FEFF;font-size: 13px;">处理中</div>
          </div>
          <div style="position: absolute;z-index: 100076; top: 33px;right: 10px;width: 70px;text-align: center">
            <div style="color: #FF3A3A;font-size: 13px;font-weight: bold;">超时处理</div>
          </div>
          <div style="position: absolute;z-index: 100076; top: 65px;right: 95px;width: 70px;text-align: center">
            <div style="color: #E8FEFF;font-size: 22px;font-weight: bold;">
              {{ tooltipDataList.length > 0 ? tooltipDataList[currentPointIndex].waitNum : 0 }}
            </div>
          </div>
          <div style="position: absolute;z-index: 100076; top: 65px;right: 10px;width: 70px;text-align: center">
            <div style="color: #FF3A3A;font-size: 22px;font-weight: bold;">{{
                tooltipDataList.length > 0 && tooltipDataList[currentPointIndex].timeoutNum ? tooltipDataList[currentPointIndex].timeoutNum : 0
              }}
            </div>
          </div>
          <img :src="$staticUrl('/statics/2025/09/16/index_bg3_20250916160239A087.png')" alt=""
               style="width: 320px;height: 160px;">
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.scrollingtablekzr2" class="bigitem scrollingtablekzr2 "
           style="top: 310px; left: 22px;position: absolute; width: 410px; height: 146px; transform: translate(0px, 0px); z-index: 1019;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;height:190px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <scrollingtable _tmplitem="336"
                          :header-row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}"
                          :row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}"
                          :isheadshow="false" :showordernum="false" :scrollnum="3" tablebackgroundcolor="#03161C"
                          tableheadcolor="rgba(21,160,151,0.2)" tablerowhovercolor="rgba(21,160,151,0.2)"
                          tablerowcolor="#03161C" tablerowdoublecolor="#03161C" tablebordercolor="rgba(3,220,228,0.2)"
                          tableheadfontcolor="#D8F0FF" tablehoverfontcolor="#fff" tablerowfontcolor="#C3D2DE"
                          :scrollheight="1" :scrolltime="40" :elcolumn="controlData.scrollingtablekzr2"
                          :tabledata="fromData.scrollingtablekzr2" :h="146" :w="410">
            <div _tmplitem="336" slot="starRating" slot-scope="scope">
              <!-- scope.row 为行对象-->
              <div _tmplitem="336">
                <i _tmplitem="336" class="el-icon-star-on" style="color:#FFCC41" v-for="item in scope.row.starRating"
                   :key="item"></i>
              </div>
            </div>
          </scrollingtable>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titleydz4" class="bigitem titleydz4 "
           style="top: 449px; left: 49px;position: absolute; width: 162px; height: 41.86px; transform: translate(0px, 0px); z-index: 1018;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="337" ref="titleydz4" :w="162" :h="41.86" :val="fromData.titleydz4"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.titlexqay" class="bigitem titlexqay "
           style="top: 110px; left: 49px;position: absolute; width: 162px; height: 41.86px; transform: translate(0px, 0px); z-index: 1017;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="338" ref="titlexqay" :w="162" :h="41.86" :val="fromData.titlexqay"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.imggh06" class="bigitem imggh06 "
           style="top: 120px; left: 22px;position: absolute; width: 410px; height: 30.35px; transform: translate(0px, 0px); z-index: 1016;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <bigimg _tmplitem="339" :url="$staticUrl('/statics/2025/09/12/bg1_20250912155317A043.png')" w="410"
                  h="30.35" rotatetype="" rotatetime=""></bigimg>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.scrollingtable4x3j" class="bigitem scrollingtable4x3j "
           style="top: 685px; left: 22px;position: absolute; width: 410px; height: 146px; transform: translate(0px, 0px); z-index: 1015;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;height:190px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <scrollingtable _tmplitem="340"
                          :header-row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}"
                          :row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}"
                          :isheadshow="false" :showordernum="false" :scrollnum="3" tablebackgroundcolor="#03161C"
                          tableheadcolor="rgba(21,160,151,0.2)" tablerowhovercolor="rgba(21,160,151,0.2)"
                          tablerowcolor="#03161C" tablerowdoublecolor="#03161C" tablebordercolor="rgba(3,220,228,0.2)"
                          tableheadfontcolor="#D8F0FF" tablehoverfontcolor="#fff" tablerowfontcolor="#C3D2DE"
                          :scrollheight="1" :scrolltime="40" :elcolumn="controlData.scrollingtable4x3j"
                          :tabledata="fromData.scrollingtable4x3j" :h="146" :w="410"></scrollingtable>
        </div>
      </div>
      <!--物业 星级 -->
      <div _tmplitem="357" v-if="readDataPermission.chartr8pa" class="bigitem chartr8pa bigechartitem"
           style="top: 130px; left: 20px;position: absolute; width: 410px; height: 197px; transform: translate(0px, 0px); z-index: 1014;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <!-- <myechart _tmplitem="341" ref="chartr8pa" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8"
                    :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chartr8pa"></myechart> -->
                    <myPie :optionsData=optionsData ref="miPieRef"></myPie>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.imgt7er" class="bigitem imgt7er "
           style="top: 460px; left: 22px;position: absolute; width: 410px; height: 30.35px; transform: translate(0px, 0px); z-index: 1013;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <bigimg _tmplitem="342" :url="$staticUrl('/statics/2025/09/12/bg1_20250912155317A043.png')" w="410"
                  h="30.35" rotatetype="" rotatetime=""></bigimg>
        </div>
      </div>

      <!-- 业主投诉 -->
      <div _tmplitem="357" v-if="readDataPermission.eltablevsqa" @click="toEvenClicek" class="bigitem eltablevsqa "
           style="top: 876px; left: 22px;position: absolute; width: 410px; height: 180px; transform: translate(0px, 0px); z-index: 1012;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent test4"
             style="--animation-linear:1;--animation-type:ease;opacity:1;height:190px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <eltable _tmplitem="343" :header-row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}"
                   :row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}" :isheadshow="true"
                   :showordernum="false" tablebackgroundcolor="#03161C" tableheadcolor="rgba(21,160,151,0.2)"
                   tablerowhovercolor="rgba(21,160,151,0.2)" tablerowcolor="#03161C" tablerowdoublecolor="#03161C"
                   tablebordercolor="rgba(3,220,228,0.2)" tableheadfontcolor="#D8F0FF" tablehoverfontcolor="#fff"
                   tablerowfontcolor="#DF4D50" :elcolumn="controlData.eltablevsqa" :tabledata="fromData.eltablevsqa"
                   :h="(37 + (tsDataLength * 33))" :w="410"></eltable>
<!-- 3 135  2 104 1 70 -->
                           <scrollingtable _tmplitem="346" :header-row-style="{'font-size':'12px','line-height':'0px','display':'none'}"
                          :row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}"
                          :isheadshow="false" :showordernum="false" :scrollnum="3" tablebackgroundcolor="#03161C"
                          tableheadcolor="#03161C" tablerowhovercolor="rgba(21,160,151,0.2)" tablerowcolor="#03161C"
                          tablerowdoublecolor="#03161C" tablebordercolor="rgba(3,220,228,0.2)" tableheadfontcolor="#fff"
                          tablehoverfontcolor="#fff" tablerowfontcolor="#C3D2DE" :scrollheight="1" :scrolltime="40"
                          :elcolumn="controlData.scrollingtablef9o2" :tabledata="fromData.scrollingtablef9o2" :h="(64 + (tsDataLength <=2 ? 30 : 0)) "
                          :w="410"></scrollingtable>
        </div>
      </div>
      <!-- 物业能力画像 -->
      <div _tmplitem="357" v-if="readDataPermission.chartn84q" class="bigitem chartn84q bigechartitem test4"
           style="top: 485px; left: 22px;position: absolute; width: 420px; height: 220px; transform: translate(0px, 0px); z-index: 1011;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <myechart _tmplitem="344" ref="chartn84q" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8"
                    :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chartn84q"></myechart>
        </div>
      </div>
      <div _tmplitem="357" class="bigitem title342j "
           style="top: 20px; left: 22px;position: absolute; width: 45px; height: 45px; transform: translate(0px, 0px); z-index: 1010;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:33px ;color:#88FCF1 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <bigimg _tmplitem="357" :url="$staticUrl('/statics/2025/09/22/logo_20250922142150A097.png')" w="40"
                  h="40" rotatetype="" rotatetime=""></bigimg>
        </div>
      </div>
      <div _tmplitem="357" class="bigitem title342j "
           style="top: 20px; left: 1840px;position: absolute; width: 45px; height: 45px; transform: translate(0px, 0px); z-index: 1010;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:33px ;color:#88FCF1 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <bigimg _tmplitem="357" :url="$staticUrl('/statics/2025/09/24/out_20250924110055A099.png')" w="40"
                  h="40" rotatetype="" rotatetime="" @click="toOut"></bigimg>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.title342j" class="bigitem title342j "
           style="top: 20px; left: 70px;position: absolute; width: 240px; height: 45px; transform: translate(0px, 0px); z-index: 1010;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:33px ;color:#88FCF1 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="345" ref="title342j" :w="480" :h="45" :val="fromData.title342j"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:33px ;color:#88FCF1 ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bolder; letter-spacing: 0.2em;font-style: italic;"></titlecontrol>
        </div>
      </div>
      <!-- 异常区  定位到业主投诉区-->
      <!-- <div _tmplitem="357" v-if="readDataPermission.scrollingtablef9o2" class="bigitem scrollingtablef9o2 "
           style="top: 880px; left: 22px;position: absolute; width: 410px; height: 180px; transform: translate(0px, 0px); z-index: 109;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;height:180px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <scrollingtable _tmplitem="346" :header-row-style="{'font-size':'12px','line-height':'18px'}"
                          :row-style="{'font-size':'12px','line-height':'18px','text-align':'center'}"
                          :isheadshow="false" :showordernum="false" :scrollnum="3" tablebackgroundcolor="#03161C"
                          tableheadcolor="#03161C" tablerowhovercolor="rgba(21,160,151,0.2)" tablerowcolor="#03161C"
                          tablerowdoublecolor="#03161C" tablebordercolor="rgba(3,220,228,0.2)" tableheadfontcolor="#fff"
                          tablehoverfontcolor="#fff" tablerowfontcolor="#C3D2DE" :scrollheight="1" :scrolltime="40"
                          :elcolumn="controlData.scrollingtablef9o2" :tabledata="fromData.scrollingtablef9o2" :h="180"
                          :w="410"></scrollingtable>
        </div>
      </div> -->
      <div _tmplitem="357" v-if="readDataPermission.datetimefalc" class="bigitem datetimefalc "
           style="top: 40px; left: 1720px;position: absolute; width: 128px; height: 22px; transform: translate(0px, 0px); z-index: 108;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:#7BE6DD ;border-radius:0px;border-width:0px ;border-style:solid ;text-align:left;font-family:'Microsoft YaHei';line-height:22px ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <comdatetime _tmplitem="347" ref="datetimefalc" w="128" h="22" format="yyyy-MM-DD"
                       cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:#7BE6DD ;border-radius:0px;border-width:0px ;border-style:solid ;text-align:left;font-family:'Microsoft YaHei';line-height:22px ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></comdatetime>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.groupbsal" class="groupbsal "
           style="overflow: hidden; width: 0px; height: 0px;top: px; left: px;position: absolute; z-index: 107;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class=""
             style=" width: 0px; height: 0px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;"></div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.gropkax3" class="gropkax3 "
           style="overflow: hidden; width: 0px; height: 0px;top: px; left: px;position: absolute; z-index: 106;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class=""
             style=" width: 0px; height: 0px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;"></div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.grouplvdc" class="grouplvdc "
           style="overflow: hidden; width: 410px; height: 41.860000000000014px;top: 828px; left: 22px;position: absolute; z-index: 105;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
        <div _tmplitem="357" class=""
             style=" width: 410px; height: 41.860000000000014px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
          <div _tmplitem="352" v-if="readDataPermission.titlep6p0" class="bigitem titlep6p0 "
               style="top: 0px; left: 27px; position: absolute;width: 162px; height: 41.86px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
            <div _tmplitem="352" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <titlecontrol _tmplitem="350" ref="titlep6p0" :w="162" :h="41.86" :val="fromData.titlep6p0"
                            cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></titlecontrol>
            </div>
          </div>
          <div _tmplitem="352" v-if="readDataPermission.img31ga" class="bigitem img31ga "
               style="top: 10px; left: 0px; position: absolute;width: 410px; height: 30.35px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
            <div _tmplitem="352" class="itemcontent "
                 style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
              <bigimg _tmplitem="351" :url="$staticUrl('/statics/2025/09/12/bg1_20250912155317A043.png')"
                      w="410" h="30.35" rotatetype="" rotatetime=""></bigimg>
            </div>
          </div>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.title6v95" class="bigitem title6v95 "
           style="top: 20px; left: 1538px;position: absolute; width: 180px; height: 46px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:38px ;color:#7BE6DD ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <comdatetime _tmplitem="353" ref="title6v95" :w="180" :h="46" format="HH:mm:ss"
                       cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:38px ;color:#7BE6DD ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bolder;"></comdatetime>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.title36p9" class="bigitem title36p9 "
           style="top: 20px; left: 725px;position: absolute; width: 470px; height: 40px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:30px ;color:#7CE6DD ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <titlecontrol _tmplitem="354" ref="title36p9" :w="470" :h="40" :val="fromData.title36p9"
                        cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:30px ;color:#7CE6DD ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bolder; letter-spacing: 0.2em;font-style: italic;"></titlecontrol>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.imgjb57" class="bigitem imgjb57 "
           style="top: 0px; left: 0px;position: absolute; width: 1946px; height: 89px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <bigimg _tmplitem="355" :url="$staticUrl('/statics/2025/09/12/head_bg_20250912155652A044.png')"
                  w="1946" h="89" rotatetype="" rotatetime=""></bigimg>
        </div>
      </div>
      <div _tmplitem="357" v-if="readDataPermission.imgaog9" class="bigitem imgaog9 "
           style="top: -1px; left: 1px;position: absolute; width: 1946px; height: 1083px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
        <div _tmplitem="357" class="itemcontent "
             style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
          <bigimg _tmplitem="356" :url="$staticUrl('/statics/2025/09/13/login_bg_20250913161329A065.png')" w="1946"
                  h="1083" rotatetype="" rotatetime=""></bigimg>
           <!-- <bigimg _tmplitem="356" url="https://govern.zyzhkjbj.com/statics/2025/09/13/bg_20250913141022A061.png" w="1946"
                  h="1083" rotatetype="" rotatetime=""></bigimg>-->
        </div>
      </div>
    </div>
    <!-- <fromdialog _tmplitem="357" ref="reffromdialog"></fromdialog> -->
  </div>
</template>
<script>
import china_130000_410500 from './china-130000-410500.json'
import * as echarts from 'echarts'
import vuecomm03xy from './vuecomm03xy.vue'
import vuecommua11 from './vuecommua11.vue'
import vuecommeqzk from './vuecommeqzk.vue'
import vuecommz4n1 from './vuecommz4n1.vue'
import vuecomm97n0 from './vuecomm97n0.vue'
import mapBg from "./mapBg.vue";
import myPie from "./myPie.vue";
import {
  getAllEstateComplaint,
  getAllEstatehandle,
  getAllEstateTodo,
  getEstateAbility,
  getEstateRanking,
  getRankingCircularDiagram,
  getOut,
  getEstateHandleData
} from '@/api/system'
import { setToken, setSidkey } from '@/utils/auth'
import {Message} from 'element-ui';
import screenAdapter from '@/mixins/screenAdapter.js'

export default {
  mixins: [screenAdapter],
  methods: {
    toOut() {
      getOut().then(res => {
        if (res.code === 200) {
          Message.success('退出登录成功')
          setToken('')
          setSidkey('')
          let fullUrl = window.location.href
          if (fullUrl.indexOf('/big?projectId=') > 0) {
            MessageBox('登录已过期！请新建浏览器窗口登录以防数据丢失！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              window.open('/login')
            })
          } else if (fullUrl.indexOf('/login') < 0) {
            window.location.href = '/login?redirect=' + encodeURIComponent(fullUrl)
          }
        }
      })
    },
    toEvenClicek() {
      window.open(`/event_intervention`, '_self')
    },
    onNotice() {
      window.open(`/notice`, '_self')
    },
    toFinanceClicek() {
      window.open(`/estateFinancialReport`, '_self')
    },
    onFunds() {
      window.open(`/funds`, '_self')
    },
    getEstateHandleData() {
      getEstateHandleData().then(res => {
         this.fromData.elstatistickmaj = res.data.estateReportNum
         this.fromData.elstatistic20qd = res.data.fundApplicationNum
      })
    },
    getEstateAbility() {
      
      // 雷达图配置化
      getEstateAbility().then(res => {
        
        this.fromData.chartn84q.legend.data = res.data.data
        res.data.series.forEach(item => {
          item.data = [item.data]
        })
   
        this.fromData.chartn84q.series = res.data.series
      })
    },
    getAllEstateTodo() {
      getAllEstateTodo().then(res => {
        this.todolist = res.data
      })
    },
    getRankingCircularDiagram() {
      getRankingCircularDiagram().then(res => {
        // this.rankingCircularDiagram = res.data
        this.fromData.chartr8pa.series[0].data = res.data
        this.optionsData = res.data
        this.$nextTick(() => {
       this.$refs.miPieRef.init(res.data)
        
       })
        
      })
    },
    getAllEstatehandle2() {
      getAllEstatehandle().then(res => {
        this.tooltipDataList = res.data
      })
    },
    getAllEstatehandle() {
      getAllEstatehandle().then(res => {

        var arr = []
        res.data.forEach((item, index) => {
          try {
            if (!item.latAndLng) {
              console.warn('缺少 latAndLng 数据', item);
              return;
            }

            let lng, lat, value = 1; // 默认热力值为1

            if (typeof item.latAndLng === 'string') {
              // 处理字符串格式
              const matches = item.latAndLng.match(/[\d.]+/g);
              if (matches && matches.length >= 2) {
                lng = parseFloat(matches[0]);
                lat = parseFloat(matches[1]);
                if (matches[2]) value = parseFloat(matches[2]);
              }
            } else if (typeof item.latAndLng === 'object') {
              // 处理对象格式
              const coords = item.latAndLng;
              lng = coords.lng || coords.longitude || 0;
              lat = coords.lat || coords.latitude || 0;
              value = coords.value || coords.val || 1;
            }

            if (lng !== undefined && lat !== undefined) {
              arr.push([lng, lat, value]);
            }
          } catch (error) {
            console.error('处理坐标时出错:', error, item);
          }
        })
        this.fromData.chartyffk.series[0].data = arr

      })
    },
    getAllEstateComplaint() {
      getAllEstateComplaint().then(res => {
        if (res && res.data) {
          // 确保 topThreeEstateRanking 存在且是数组
          let lengths = 0
          if (Array.isArray(res.data.topThreeEstateRanking)) {
            res.data.topThreeEstateRanking.forEach((item, index) => {
              item.ranking = index + 1;
            });
            this.tsDataLength = res.data.topThreeEstateRanking.length
            this.fromData.eltablevsqa = res.data.topThreeEstateRanking
            lengths = res.data.topThreeEstateRanking.length
          }

          // 确保 remainingEstateRanking 存在且是数组
          if (Array.isArray(res.data.remainingEstateRanking)) {
            res.data.remainingEstateRanking.forEach((ritem, rindex) => {
              ritem.ranking = rindex + lengths + 1;
            });
            this.fromData.scrollingtablef9o2 = res.data.remainingEstateRanking;
          }
          return;
          if (Array.isArray(res.data.remainingEstateRanking) && Array.isArray(res.data.topThreeEstateRanking)) {
            const all = [ ...res.data.remainingEstateRanking,...res.data.topThreeEstateRanking]
           const tsData =  all.map((row,i) => {
        row.ranking = i + 1;

        return row
           })
       
            this.fromData.scrollingtablef9o2 =tsData;

       
          }
          
        }
      })
    },
    getEstateRanking() {
      getEstateRanking().then(res => {
        res.data.forEach((item, index) => {
          item.ranking = index + 1
        })
        this.fromData.scrollingtablekzr2 = res.data
        this.fromData.scrollingtable4x3j = res.data

      })
    },
    onUnder() {
      Message.info('功能开发中，敬请期待！');
    },
    initHeatmapTooltips() {
      const chart = this.$refs.chartyffk && this.$refs.chartyffk.getMychart();
      if (!chart) {
        console.warn('未获取到图表实例');
        return;
      }

      // 清除之前的定时器
      if (this.tooltipTimer) {
        clearInterval(this.tooltipTimer);
      }

      try {
        // 获取图表配置选项
        const option = chart.getOption() || {};

        // 确保series存在
        if (!option.series || !Array.isArray(option.series)) {
          console.warn('未找到有效的series配置');
          return;
        }

        // 查找热力图系列
        const heatmapSeries = option.series.find(s => s && s.type === 'heatmap');
        if (!heatmapSeries || !heatmapSeries.data || !Array.isArray(heatmapSeries.data) || heatmapSeries.data.length === 0) {
          console.warn('未找到热力图数据或数据格式不正确');
          return;
        }

        // 设置当前显示的点索引
        this.currentPointIndex = -1; // 从-1开始，因为showNextTooltip中会先+1

        // 开始循环显示提示框
        this.showNextTooltip(chart, heatmapSeries.data);

        // 设置定时器，每隔3秒切换到下一个点
        this.tooltipTimer = setInterval(() => {
          this.showNextTooltip(chart, heatmapSeries.data);
        }, 10000);
      } catch (error) {
        console.error('初始化热力图提示框时出错:', error);
      }
    },

    // 显示下一个提示框
    showNextTooltip(chart, points) {
      if (points.length === 0) return;

      // 更新当前点索引
      this.currentPointIndex = (this.currentPointIndex + 1) % points.length;
      const point = points[this.currentPointIndex];

      // 确保数据格式正确 [lng, lat, value]
      if (!Array.isArray(point) || point.length < 3) return;

      const [lng, lat, value] = point;

      // 将经纬度转换为像素坐标
      const pixel = chart.convertToPixel(
          {type: 'geo', geoIndex: 0},
          [lng, lat]
      );

      if (!pixel) return;

      // 更新提示框数据
      this.tooltipData = {
        name: `热力点 ${this.currentPointIndex + 1}`,
        desc: `经度: ${lng.toFixed(4)}°\\n纬度: ${lat.toFixed(4)}°`,
        value: value
      };

      // 更新提示框位置
      this.tooltipLeft = pixel[0] + 0 + 576;  // 向右偏移
      this.tooltipTop = pixel[1] - 160 + 288;   // 向上偏移
      this.tooltipVisible = true;

      // 2.5秒后自动隐藏
      setTimeout(() => {
        this.tooltipVisible = false;
      }, 9500);
    },

    created_sys() {
      ///系统方法 判断页面大小 使其自动适应
      let $this = this
      this.w = this.w === undefined ? 1920 : this.w
      $this.css = $this.fullScreenCss($this, this.screentype)
      window.addEventListener('resize', () => {
        $this.css = $this.fullScreenCss($this, this.screentype)
      })
      if (this.loadfunmounted_sys !== undefined) {
        this.$nextTick(() => {
          this.loadfunmounted_sys()
        })
      }
    },
    loadsysmounted() {
      echarts.registerMap("china_130000_410500", china_130000_410500);
    },
    // 添加数据刷新方法
    refreshData() {
      // console.log('开始刷新数据...');
      // 这里添加您的数据获取逻辑
      // 例如：
      // this.fetchData();
      this.getAllEstatehandle2()

    },

    // 启动定时器
    startDataRefresh() {
      // 先清除已有的定时器
      this.stopDataRefresh();

      // 立即执行一次数据刷新
      this.refreshData();

      // 设置定时器
      this.dataRefreshTimer = setInterval(() => {
        this.refreshData();
      }, this.refreshInterval);
    },

    // 停止定时器
    stopDataRefresh() {
      if (this.dataRefreshTimer) {
        clearInterval(this.dataRefreshTimer);
        this.dataRefreshTimer = null;
      }
    },

    // 修改刷新间隔
    setRefreshInterval(interval) {
      this.refreshInterval = interval;
      this.startDataRefresh(); // 重新启动定时器以应用新的间隔
    }
  },
  created() {
    this.getEstateHandleData()
    this.getEstateAbility()
    this.getAllEstatehandle()
    this.getAllEstateComplaint();
    this.getEstateRanking()
    this.getAllEstateTodo()
    this.getRankingCircularDiagram()
    // this.getUserInfo()
    this.created_sys()
    if (this.loadfunmounted !== undefined) {
      this.$nextTick(() => {
        this.loadfunmounted();
      });
    }
    // 获取当前日期的星期几（0-6，0表示周日）
    const day = new Date().getDay();

    // 将数字转换为中文星期
    const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
    this.fromData.title6tls = `星期${weekDays[day]}`;

  },
  mounted() {
    this.startDataRefresh();
    // 组件挂载后强制重新计算全屏尺寸
    this.$nextTick(() => {
      this.css = this.fullScreenCss(this, this.screentype)
    })
    // 组件挂载后，初始化 ECharts 事件（只执行一次）
    setTimeout(() => {
      this.initHeatmapTooltips();
    }, 2000);
  },
  beforeDestroy() {
    this.stopDataRefresh();
    if (this.tooltipTimer) {
      clearInterval(this.tooltipTimer);
    }
  },
  data() {
    return {
      tsDataLength:0,
      optionsData:[],// 3d饼图数据
      dataRefreshTimer: null, // 数据刷新定时器
      refreshInterval: 11800, // 默认5秒刷新一次，可以根据需要调整

      // 缓存 ECharts 实例（避免重复获取）
      echartInstance: null,
      // 弹窗相关状态
      tooltipData: null,
      tooltipVisible: false,
      tooltipLeft: 0,
      tooltipTop: 0,
      currentPointIndex: 0,
      tooltipTimer: null,
      hideTimer: null,
      tooltipDataList: [],
      todolist: [],

      w: 1920,
      css: ``,
      h: 1080,
      bg: ``,
      bgColor: `rgb(43 44 45)`,
      fromData: {
        elstatisticses3: 409,
        titleo00r: `业主自治`,
        elstatisticv6j3: 2,
        titlerfmk: `业委会`,
        elstatisticz0ua: 44,
        title8paa: `业主投票`,
        elstatisticzaet: 8080,
        titlespec: `缴费情况`,
        elstatistic20qd: 1843,
        titleqbve: `资金申请`,
        elstatistickmaj: 80,
        titleggxx: `物业财报`,
        elstatistic1ay7: 689,
        title69s1: `社区党建`,
        titlev940: `权限管理`,
        titleca4z: `企业奖惩`,
        titlejx91: `部门协同`,
        titleogry: `物业通知`,
        titlejp46: `事件介入处理`,
        titlek7hh: `企业档案`,
        titlem0h3: `物业待办事件`,
        eltableuzwk: [{
          ranking: `01`,
          name: `A物业名称`,
          number: `100%`
        }, {
          ranking: `02`,
          name: `A物业名称`,
          number: `100%`
        }, {
          ranking: `03`,
          name: `A物业名称`,
          number: `100%`
        }],
        scrollingtable8d40: [{
          ranking: `01`,
          name: `A物业名称`,
          number: `10%`
        }, {
          ranking: `02`,
          name: `A物业名称`,
          number: `10%`
        }, {
          ranking: `03`,
          name: `A物业名称`,
          number: `10%`
        }],
        title8r6h: `卫生`,
        title6tqt: `安保`,
        titlemhfg: `绿化`,
        titlevrtc: `设施`,
        title2kr7: `综合`,
        title51he: `详情`,
        titleu739: `详情`,
        titlel4z0: `详情`,
        titlewpr7: `详情`,
        titlejllp: `详情`,
        titlebo0q: `详情`,
        titled0ef: `详情`,
        title9oqd: `详情`,
        titled8ag: `详情`,
        title3x4x: `物业作业达成率`,
        chartfxf1: {
          backgroundColor: ``,
          legend: {
            data: [`已处理`, `处理中`, `超时处理`],
            textStyle: {
              color: `#ccc`
            },
            right: 10
          },
          grid: {
            containLabel: true,
            top: 30,
            left: 10,
            right: 50,
            bottom: 0
          },
          tooltip: {
            show: true,
            backgroundColor: `#fff`,
            borderColor: `#ddd`,
            borderWidth: 1,
            textStyle: {
              color: `#3c3c3c`,
              fontSize: 16
            },
            extraCssText: `box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)`
          },
          xAxis: {
            splitNumber: 4,
            interval: 200,
            max: 800,
            min: 0,
            axisLabel: {
              show: true,
              color: `#C5DCFF`,
              textStyle: {
                fontSize: 10
              },
              margin: 10
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: `rgba(255, 255, 255, 0.2)`
              }
            },
            axisTick: {
              show: true,
              length: 5,
              lineStyle: {
                color: `rgba(255, 255, 255, 0.3)`
              }
            },
            splitLine: {
              show: true,
              interval: `auto`,
              lineStyle: {
                color: `rgba(255, 255, 255, 0.1)`,
                width: 1
              }
            }
          },
          yAxis: [{
            data: [`地下淹水告警`, `停车驱离告警`, `配电热敏告警`, `噪音数值`, `管道爆燃预警`, `水质安全告警`, `楼宇安全预警`, `电梯安全预警`, `高空抛物`],
            axisLabel: {
              fontSize: 12,
              color: `#fff`
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            }
          }],
          series: [{
            type: `bar`,
            name: `已处理`,
            stack: `2`,
            label: {
              normal: {
                show: true,
                position: `inside`,
                textStyle: {
                  color: `#fff`,
                  fontSize: 12
                }
              }
            },
            legendHoverLink: false,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: `#0090EA`
              },
              emphasis: {
                color: `#0090EA`
              }
            },
            data: [98, 98, 150, 98, 150, 285, 300, 103, 234]
          }, {
            type: `bar`,
            name: `处理中`,
            stack: `2`,
            legendHoverLink: false,
            barWidth: 20,
            label: {
              normal: {
                show: true,
                position: `inside`,
                textStyle: {
                  color: `#fff`,
                  fontSize: 12
                }
              }
            },
            itemStyle: {
              normal: {
                color: `#03E7C5`
              },
              emphasis: {
                color: `#03E7C5`
              }
            },
            data: [100, 190, 50, 190, 150, 140, 70, 256, 208]
          }, {
            type: `bar`,
            stack: `2`,
            name: `超时处理`,
            legendHoverLink: false,
            barWidth: 20,
            label: {
              normal: {
                show: true,
                position: `inside`,
                textStyle: {
                  color: `#fff`,
                  fontSize: 12
                }
              }
            },
            itemStyle: {
              normal: {
                color: `#F8AD24`
              },
              emphasis: {
                color: `#F8AD24`
              }
            },
            data: [310, 210, 550, 100, 130, 350, 310, 210, 110]
          }]
        },
        titleww22: `安全感知事件`,
        title6tls: `星期五`,
        // 地图配置
        chartyffk: {
          visualMap: {
            show: false,
            min: 0,
            max: 400,
            splitNumber: 5,
            inRange: {
              symbol: `circle`,
              color: [`#f1ea29`, `#f1b629`, `#ff8400`, `#ff2a00`]
            },
            textStyle: {
              color: `#000`
            }
          },
          geo: {

            map: `china_130000_410500`,
            data: [], // 关键：添加空数据数组，确保交互触发
            tooltip: {show: true}, // 关键：显式启用热力点的 tooltip 交互
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  const spacedName = params.name.split("").join("\u2006") 
                  return `{nameStyle|${spacedName}}`
                },

                color: "#f8f9fa",
                fontWeight: "600",
                fontSize: 18,
                textShadowColor: "rgba(0, 0, 0, 0.9)",
                textShadowBlur: 10,
                textShadowOffsetX: 3,
                textShadowOffsetY: 3,
                rich: {
                  nameStyle: {
                    color: "#f8f9fa",
                    fontWeight: "600",
                    fontSize: 18,
                    // 阴影效果也可以移至此处，以确保一致性
                    textShadowColor: "rgba(0, 0, 0, 0.9)",
                    textShadowBlur: 10,
                    textShadowOffsetX: 3,
                    textShadowOffsetY: 3
                  }
                }
              },
              emphasis: {
                show: true,
                formatter: function (params) {
                  const spacedName = params.name.split("").join("\u2006")
                  return `{nameStyle|${spacedName}}`
                },
                color: "#fff",
                textShadowColor: "rgba(0, 0, 0, 1)",
                textShadowBlur: 6,
                textShadowOffsetX: 2,
                textShadowOffsetY: 2,
                rich: {
                  nameStyle: {
                    color: "#fff",
                    textShadowColor: "rgba(0, 0, 0, 1)",
                    textShadowBlur: 6,
                    textShadowOffsetX: 2,
                    textShadowOffsetY: 2
                  }
                }
              }
            },
            roam: false,
            zoom: 1.2,
            itemStyle: {
              normal: {
                borderColor: `rgba(147, 235, 248, 1)`,
                borderWidth: 1,
                areaColor: {
                  type: `radial`,
                  x: 0.5,
                  y: 0.5,
                  r: 0.8,
                  colorStops: [{
                    offset: 0,
                    // color: `rgba(147, 235, 248, 0.4)`
                    color: `rgba(56, 155, 183, 0.8)`
                  }, {
                    offset: 1,
                    // color: `rgba(147, 235, 248, .8)`
                    color: `rgba(56, 155, 183, 1)`
                  }],
                  globalCoord: false
                },
                shadowColor: `rgba(128, 217, 248, 0.4)`,
                shadowOffsetX: 3,
                shadowOffsetY: 6,
                shadowBlur: 1
              },
              emphasis: {
                // areaColor: `#389BB7`,
                areaColor: `#02b1e1`,
                borderWidth: 1,
                blurSize: 0, // 新增：取消高亮模糊，避免遮挡

                //  areaColor: '#3ADAF4',        // 更亮的蓝色
  //                areaColor: '#52bdda',        // 更亮的蓝色
  borderColor: '#3ADAF4',      // 白色边框
  // borderWidth: 1,              // 增加边框宽度
              }
            }
          },
          series: [{
            name: `热力值`,
            type: `heatmap`,
            coordinateSystem: `geo`,
            zlevel: 2, // 高于 geo 的 zlevel（默认 0），确保热力点在顶层
            tooltip: {show: true}, // 关键：显式启用热力点的 tooltip 交互
            data: [],
            // 热力图样式
            blurSize: 10, // 模糊程度
            pointSize: 15, // 点大小
            // 热力点上的文字标注
          }],
          tooltip: {
            trigger: `item`,
            triggerOn: "mousemove|click", // 鼠标悬停/点击都触发弹窗（增强交互）
            backgroundColor: "rgba(10, 25, 50, 0.95)", // 弹窗背景（半透明，不遮挡地图）
            borderColor: "#40e0d0", // 弹窗边框（与高亮文字同色，统一风格）
            borderWidth: 1,
            borderRadius: 6, // 弹窗圆角（优化视觉）
            padding: 12, // 弹窗内边距（避免内容拥挤）
            textStyle: {
              color: "#fff",
              // color: "#ff2b00",
              fontSize: 18,
              lineHeight: 1.6 // 行高（提升可读性）
            },
            // 4. 弹窗内容优化（显示名称+坐标+热力值，兼容热力点/区域）
            formatter: (params) => {
              if (params.seriesType === "heatmap") {
                // 热力点弹窗：显示名称（从data第4位获取）、坐标、热力值
                const pointName = params.value[3] || "未知热力区域"; // 取data第4位作为名称
                const lng = params.value[0].toFixed(2); // 经度保留2位小数
                const lat = params.value[1].toFixed(2); // 纬度保留2位小数
                const heatValue = params.value[2];
                return "<div style=\"font-weight:bold;color:#40e0d0;margin-bottom:8px;\">" + pointName + "</div>" +
                    "<div style=\"margin:4px 0;\">经纬度：" + lng + ", " + lat + "</div>" +
                    "<div style=\"margin:4px 0;\">热力值：" + heatValue + "</div>";
              } else if (params.componentType === "geo") {
                // 地图区域弹窗：显示区域名称+自定义信息（如行政级别）
                return [
                  '<div style="font-weight:bold;color:#40e0d0;margin-bottom:8px;">',
                  params.name,
                  '</div>',
                  '<div style="margin:4px 0;">行政级别：',
                  params.name.includes("市") ? "地级市" : "县级市",
                  '</div>',
                  '<div style="margin:4px 0;">区域编码：',
                  params.data && params.data.code ? params.data.code : "未配置",
                  '</div>'
                ].join('');
              }
            },
            // 5. 弹窗动画（优化体验）
            transitionDuration: 0.3, // 弹窗显示/隐藏动画时长
            enterable: true // 允许鼠标进入弹窗（若弹窗内有交互元素，如链接）
          }
        },
        // 地图
        scrollingtablekzr2: [],
        titleydz4: `物业能力画像`,
        titlexqay: `物业星级排名`,
        scrollingtable4x3j: [],

        // 物业星级
        chartr8pa: {
          title: {
            text: ``,
            left: `24%`,
            top: `center`,
            textStyle: {
              fontSize: 24
            }
          },
          tooltip: {
            trigger: `item`
          },
          legend: {
            type: `scroll`,
            orient: `vertical`,
            right: `15%`,
            top: `center`,
            selectedMode: true,
            icon: `rect`,
            textStyle: {
              rich: {
                a: {
                  color: `#666666`,
                  fontSize: 14,
                  fontWeight: 500,
                  width: 30,
                  padding: [0, 0, 25, 2]
                },
                b0: {
                  color: `#666666`,
                  fontSize: 14,
                  fontWeight: 500,
                  height: 20,
                  padding: [0, 30, 8, 4]
                },
                b1: {
                  fontSize: 20,
                  padding: [0, 30, 0, 40]
                },
                b2: {
                  fontSize: 20,
                  padding: [0, 30, 0, 40]
                },
                b3: {
                  fontSize: 20,
                  padding: [0, 30, 0, 40]
                }
              }
            }
          },
          series: [{
            type: `pie`,
            center: [`30%`, `50%`],
            radius: [`50%`, `70%`],
            clockwise: true,
            avoidLabelOverlap: true,
            hoverOffset: 2,
            tooltip: {
              trigger: `item`,
              backgroundColor: `#f3f3f3`,
              textStyle: {
                color: `#666666`,
                fontSize: 14,
                fontWeight: 500
              },
              padding: [10, 20],
              extraCssText: `box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);`
            },
            emphasis: {
              itemStyle: {
                // borderColor: `#f3f3f3`,
                borderColor: `#d65c5c`,
                borderWidth: 5
              }
            },
            itemStyle: {
              normal: {}
            },
            label: {
              show: false,
              position: `outside`,
              formatter: `{a|{b}：{d}%}
{hr|}`,
              rich: {
                hr: {
                  backgroundColor: `t`,
                  borderRadius: 1,
                  width: 1,
                  height: 1,
                  padding: [1, 1, 0, -4]
                },
                a: {
                  padding: [-15, 7, -10, 7]
                }
              }
            },
            labelLine: {
              normal: {
                length: 10,
                length2: 15,
                lineStyle: {
                  width: 1
                }
              }
            },
            data: []
          }]
        },
        eltablevsqa: [],
        // 雷达图
        chartn84q: {
          backgroundColor: `rgba(0, 0, 0, 0)`,
          title: {
            text: ``
          },
          legend: {
            orient: `vertical`,
            icon: `circle`,
            data: [`华信物业`, `嘉诚物业`],
            // bottom: `50%`,
             top: '10%',
            right: `2%`,
            // left:20,
            itemWidth: 12,
            itemHeight: 10,
            itemGap: 16,
            textStyle: {
              fontSize: 12,
              color: `#fff`,
    lineHeight: 15,  // 增加上下间距
    textAlign: 'center'  // 居中文本
            },
            formatter: function(name) {
                            // 每2个字换一行
                let result = '';
                for (let i = 0; i < name.length; i++) {
                result += name[i];
                if ((i + 1) % 8 === 0 && i !== name.length - 1) {
                result += '\n';
        }

}

return result;

}
          },
          radar: {
            radius: `68%`,
            center: [`32%`, `52%`],
            startAngle: 90,
            triggerEvent: true,
              // axisName: {
              //           formatter: function(value) {
              //               // 雷达图指示器名称换行处理
              //               if (value.length > 6) {
              //                   return value.replace(/(.{6})/g, '$1\n');
              //               } else {
              //                   return value;
              //               }
              //           },
              //           color: '#fff',
              //           fontSize: 12,
              //           borderRadius: 0,
              //           padding: [0, 0]
              //       },

            // 
            name: {
              textStyle: {
                color: `#fff`,
                fontSize: `10`,
                borderRadius: 0,
                padding: [0, 0],
                whiteSpace: `normal`
              }
            },
            nameGap: `5`,
            indicator: [{
              name: `服务态度积极`,
              min: 0,
              max: 5
            }, {
              name: `清洁卫生管理`,
              min: 0,
              max: 5
            }, {
              name: `绿化维持养护`,
              min: 0,
              max: 5
            }, {
              name: `公共设施维护`,
              min: 0,
              max: 5
            }, {
              name: `安保秩序维护`,
              min: 0,
              max: 5
            }],
            splitArea: {
              areaStyle: {
                color: [`rgba(255, 255, 255, 0)`, `rgba(255, 255, 255, 0)`, `rgba(255, 255, 255, 0)`, `rgba(255, 255, 255, 0)`, `rgba(255, 255, 255, 0)`, `rgba(255, 255, 255, 0)`],
                shadowColor: `rgba(0, 0, 0, 1)`,
                shadowBlur: 30,
                shadowOffsetX: 10,
                shadowOffsetY: 10
              }
            },
            axisLine: {
              lineStyle: {
                color: `rgba(31, 150, 217, 1)`
              }
            },
            splitLine: {
              lineStyle: {
                width: 1,
                color: [`rgba(31, 150, 217, 1)`, `rgba(31, 150, 217, 1)`, `rgba(31, 150, 217, 1)`, `rgba(31, 150, 217, 1)`, `rgba(31, 150, 217, 1)`, `rgba(31, 150, 217, 1)`]
              }
            }
          },
          series: [{
            name: `华信物业`,
            type: `radar`,
            symbol: `circle`,
            symbolSize: 6,
            itemStyle: {
              color: `rgba(117, 224, 160, 1)`,
              borderColor: `rgba(117, 224, 160, 1)`,
              borderWidth: 6
            },
            lineStyle: {
              color: `rgba(117, 224, 160, 0.6)`,
              width: 2
            },
            label: {
              show: false
            },
            areaStyle: {
              normal: {
                width: 1,
                opacity: 0.3,
                shadowColor: `rgba(0, 0, 0, .5)`,
                shadowBlur: 3,
                shadowOffsetX: 15,
                shadowOffsetY: 15
              },
              color: `rgba(117, 224, 160, 0.5)`
            },
            data: [
              [5, 4, 5, 2, 1]
            ]
          }, {
            name: `嘉诚物业`,
            type: `radar`,
            symbol: `circle`,
            symbolSize: 6,
            itemStyle: {
              color: `rgba(39, 173, 250, 1)`,
              borderColor: `rgba(39, 173, 250, 1)`,
              borderWidth: 6
            },
            lineStyle: {
              color: `rgba(39, 173, 250, 1)`,
              width: 2
            },
            label: {
              show: false
            },
            areaStyle: {
              normal: {
                width: 1,
                opacity: 0.3,
                shadowColor: ``,
                shadowBlur: 3,
                shadowOffsetX: 15,
                shadowOffsetY: 15
              },
              color: `rgba(39, 173, 250, 1)`
            },
            data: [
              [40, 40, 60, 75, 85]
            ]
          }]
        },
        // 
        title342j: `中耘城市管理态势感知系统`,
        scrollingtablef9o2: [],
        titlep6p0: `业主投诉建议`,
        title6v95: `09:56:15`,
        title36p9: `汤阴县智慧物业监管平台`
      },
      controlTimer: {},
      controlData: {
        eltableuzwk: [{
          prop: `ranking`,
          label: `排名`,
          width: `90`,
          minwidth: `120`,
          align: ``,
          istotal: false,
          flexAlign: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          showOverflowTooltip: false
        }, {
          prop: `name`,
          label: `物业`,
          width: `210`,
          minwidth: `120`,
          align: ``,
          istotal: false,
          flexAlign: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          showOverflowTooltip: false
        }, {
          prop: `number`,
          label: `达成率`,
          width: `110`,
          istotal: false,
          flexAlign: ``,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          showOverflowTooltip: false
        }],
        scrollingtable8d40: [{
          prop: `ranking`,
          label: `排名`,
          width: `90`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: `180`,
          flexAlign: ``,
          showOverflowTooltip: false
        }, {
          prop: `name`,
          label: `物业`,
          width: `210`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: `180`,
          flexAlign: ``,
          showOverflowTooltip: false
        }, {
          prop: `number`,
          label: `达成率`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: ``,
          flexAlign: ``,
          showOverflowTooltip: false,
          width: `110`
        }],
        scrollingtablekzr2: [{
          prop: `ranking`,
          label: `排名`,
          width: `90`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: `180`,
          flexAlign: ``,
          showOverflowTooltip: false
        }, {
          prop: `estateName`,
          label: `物业`,
          width: `210`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: `180`,
          flexAlign: ``,
          showOverflowTooltip: false
        }, {
          prop: `starRating`,
          label: `星级`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: `<!-- scope.row 为行对象-->
<div>
    <i class="el-icon-star-on" style="color:#FFCC41" v-for="item in scope.row.starRating" :key="item"></i>
</div>`,
          headscopehtml: ``,
          minwidth: ``,
          flexAlign: ``,
          showOverflowTooltip: false,
          width: `110`,
          isslot: true
        }],
        scrollingtable4x3j: [{
          prop: `ranking`,
          label: `排名`,
          width: `90`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: `180`,
          flexAlign: ``,
          showOverflowTooltip: false
        }, {
          prop: `estateName`,
          label: `物业`,
          width: `210`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: `180`,
          flexAlign: ``,
          showOverflowTooltip: false
        }, {
          prop: `totalScore`,
          label: `综合能力`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: ``,
          flexAlign: ``,
          showOverflowTooltip: false,
          width: `110`
        }],
        eltablevsqa: [{
          prop: `ranking`,
          label: `排名`,
          width: `90`,
          minwidth: `120`,
          align: ``,
          istotal: false,
          flexAlign: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          showOverflowTooltip: false
        }, {
          prop: `estateName`,
          label: `物业`,
          width: `210`,
          minwidth: `120`,
          align: ``,
          istotal: false,
          flexAlign: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          showOverflowTooltip: false
        }, {
          prop: `complaintNum`,
          label: `投诉数量`,
          width: `110`,
          istotal: false,
          flexAlign: ``,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          showOverflowTooltip: false
        }],
        scrollingtablef9o2: [{
          prop: `ranking`,
          label: `排名`,
          width: `90`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: `180`,
          flexAlign: ``,
          showOverflowTooltip: false
        }, {
          prop: `estateName`,
          label: `物业`,
          width: `210`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: `180`,
          flexAlign: ``,
          showOverflowTooltip: false
        }, {
          prop: `complaintNum`,
          label: `投诉数量`,
          align: ``,
          headeralign: ``,
          classname: ``,
          scopehtml: ``,
          headscopehtml: ``,
          minwidth: ``,
          flexAlign: ``,
          showOverflowTooltip: false,
          width: `110`
        }]
      },
      screentype: `full`,
      readDataPermission: {
        elstatisticses3: true,
        titleo00r: true,
        img3w5v: true,
        group15r4: true,
        elstatisticv6j3: true,
        titlerfmk: true,
        imgtp15: true,
        groupgkxn: true,
        elstatisticz0ua: true,
        title8paa: true,
        imgd3oa: true,
        groupaf5n: true,
        elstatisticzaet: true,
        titlespec: true,
        imgry1w: true,
        groupowma: true,
        elstatistic20qd: true,
        titleqbve: true,
        img4zvh: true,
        groupcqju: true,
        elstatistickmaj: true,
        titleggxx: true,
        imgam55: true,
        group3hoz: true,
        vuecomm03xy: true,
        elstatistic1ay7: true,
        title69s1: true,
        img6qy3: true,
        grop2taf: true,
        title7rdo: true,
        formselect2pb8: true,
        vuecommua11: true,
        groupkx3n: true,
        title7vu8: true,
        formselectdfgs: true,
        vuecommeqzk: true,
        groupxlwe: true,
        titlefg8l: true,
        formselecte4ts: true,
        vuecommz4n1: true,
        group9w6z: true,
        titleoobw: true,
        formselectuw81: true,
        vuecomm97n0: true,
        gropaguw: true,
        titlev940: true,
        imgfm5d: true,
        imgkp9k: true,
        groupjw0x: true,
        titleca4z: true,
        imgrmh2: true,
        imgta96: true,
        group8sm7: true,
        titlejx91: true,
        img265r: true,
        imghaz6: true,
        groupxhta: true,
        titleogry: true,
        img83qo: true,
        imga6n7: true,
        groupfuav: true,
        titlejp46: true,
        imgk4ch: true,
        imgudgm: true,
        group2e8g: true,
        titlek7hh: true,
        imghk3g: true,
        imgd9qs: true,
        gropt4bd: true,
        titlem0h3: true,
        img8tvq: true,
        eltableuzwk: true,
        scrollingtable8d40: true,
        title8r6h: true,
        title6tqt: true,
        titlemhfg: true,
        titlevrtc: true,
        title2kr7: true,
        groplyas: true,
        title51he: true,
        titleu739: true,
        titlel4z0: true,
        titlewpr7: true,
        titlejllp: true,
        titlebo0q: true,
        titled0ef: true,
        title9oqd: true,
        titled8ag: true,
        title3x4x: true,
        imgb8x0: true,
        chartfxf1: true,
        titleww22: true,
        imgrng4: true,
        title6tls: true,
        chartyffk: true,
        imgwyau: true,
        grop7cta: true,
        scrollingtablekzr2: true,
        titleydz4: true,
        titlexqay: true,
        imggh06: true,
        scrollingtable4x3j: true,
        chartr8pa: true,
        imgt7er: true,
        eltablevsqa: true,
        chartn84q: true,
        title342j: true,
        scrollingtablef9o2: true,
        datetimefalc: true,
        groupbsal: true,
        gropkax3: true,
        titlep6p0: true,
        img31ga: true,
        grouplvdc: true,
        title6v95: true,
        title36p9: true,
        imgjb57: true,
        imgaog9: true
      },
    }
  },
  components: {
    vuecomm03xy,
    vuecommua11,
    vuecommeqzk,
    vuecommz4n1,
    vuecomm97n0,
    mapBg,
    myPie
  }
}
</script>
<style scoped>

.dv-full-screen-container {
  transform: scale(1);
  position: absolute;
  top: 0px;
  left: 0px;
  overflow: hidden;
  transform-origin: left top;
  z-index: 499;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 1920px;
  height: 1080px;
  background-color: '#040404';
  background-size: cover;
  background-repeat: no-repeat;
}

.div-full-screen {
  background-size: cover;
  background-repeat: no-repeat;
}

.animation-revolve {
  animation: revolve 1s linear infinite;
}

@keyframes revolve {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.bigitem {
  position: absolute;
  will-change: transform;
}

.bigechartitem:hover {
  z-index: 1900 !important;
}

.layouttable {
  height: 100%;
  display: flex;
}

.layouttable .layouttable-item {
  height: 100%;
  position: relative;
  float: left;
}

.itemcontent {
  width: 100%;
  height: 100%;
}

.bigbutton {
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>
<style>
@keyframes floating {
  0%,
  100% {
    transform: translateY(0); /* 初始位置和结束位置都是原始位置 */
  }
  50% {
    transform: translateY(-12px); /* 上浮 */
  }
}
@keyframes floating2 {
  0%,
  100% {
    transform: translateY(0); /* 初始位置和结束位置都是原始位置 */
  }
  50% {
    transform: translateY(10px); /* 上浮 */
  }
}
@keyframes floating3 {
  0%,
  100% {
    transform: translateY(0); /* 初始位置和结束位置都是原始位置 */
  }
  50% {
    transform: translateY(-12px); /* 上浮 */
  }
}
.foolt {
  animation: floating 3s ease-in-out infinite !important; /* 使用动画 */
}
.foolt2 {
  animation: floating2 3s ease-in-out infinite !important; /* 使用动画 */
}
.foolt3 {
  animation: floating3 3s ease-in-out infinite !important; /* 使用动画 */
}


</style>
